import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withKeys as _withKeys, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]
const _hoisted_2 = { class: "nge-radio-now" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "nge-radio-kicker" }, "EyeWire Radio", -1 /* HOISTED */)
const _hoisted_4 = ["title"]
const _hoisted_5 = ["tabindex"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.2 8a4.8 4.8 0 1 0 1.5-3.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 2.6v2.7h2.7" })
], -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["tabindex"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 3.4v9.2a.5.5 0 0 0 .8.4L10 8.4a.5.5 0 0 0 0-.8L3.800 3a.5.5 0 0 0-.8.4z" }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "11.300",
    y: "3",
    width: "1.700",
    height: "10",
    rx: ".6"
  })
], -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["value", "tabindex", "title"]
const _hoisted_12 = {
  class: "nge-radio-volnum",
  "aria-hidden": "true"
}
const _hoisted_13 = ["title", "aria-label", "aria-pressed"]
const _hoisted_14 = {
  viewBox: "0 0 20 20",
  width: "18",
  height: "18",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.200 7.700h2.500l3.600-3v10.600l-3.600-3H3.200z",
  fill: "currentColor",
  "fill-opacity": ".18"
}, null, -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  d: "M12.600 7.800l4 4.400M16.600 7.800l-4 4.400"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  class: "nge-radio-wave nge-radio-wave--1",
  d: "M12.200 7.600a3.400 3.400 0 0 1 0 4.800"
}, null, -1 /* HOISTED */)
const _hoisted_18 = {
  key: 0,
  class: "nge-radio-wave nge-radio-wave--2",
  d: "M14.300 5.600a6.200 6.200 0 0 1 0 8.800"
}
const _hoisted_19 = {
  class: "nge-radio-progress",
  "aria-hidden": "true"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref: "rootEl",
      class: _normalizeClass(["nge-radio", { 'nge-radio--on': $setup.on, 'nge-radio--playing': $setup.playing, 'nge-radio--open': $setup.expanded, 'holo-on': $setup.expanded }]),
      style: _normalizeStyle({ '--nge-radio-dock': $setup.dock + 'px', '--nge-radio-lift': $setup.lift + 'px', '--nge-radio-base': $setup.base + 'px', '--nge-radio-shift': $setup.shift + 'px' }),
      onPointerenter: _cache[0] || (_cache[0] = $event => {$setup.hovering = true; $setup.expanded = true}),
      onPointerleave: $setup.onLeave,
      onFocusin: $setup.onFocusIn,
      onFocusout: $setup.onFocusOut,
      onKeydown: _cache[1] || (_cache[1] = _withKeys($event => ($setup.expanded = false), ["esc"])),
      onWheel: $setup.onWheel
    }, [
      _createElementVNode("div", {
        class: "nge-radio-tray",
        "aria-hidden": !$setup.expanded
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "nge-radio-title",
            title: $setup.current?.title
          }, _toDisplayString($setup.loadError ? 'The station is off the air' : $setup.current ? $setup.current.title : 'Music while you play'), 9 /* TEXT, PROPS */, _hoisted_4)
        ]),
        _createElementVNode("button", {
          class: "nge-radio-btn",
          tabindex: $setup.expanded ? 0 : -1,
          title: "Start this song again",
          "aria-label": "Start this song again",
          onClick: $setup.restart
        }, _hoisted_7, 8 /* PROPS */, _hoisted_5),
        _createElementVNode("button", {
          class: "nge-radio-btn",
          tabindex: $setup.expanded ? 0 : -1,
          title: "Skip to the next song",
          "aria-label": "Skip to the next song",
          onClick: $setup.skip
        }, _hoisted_10, 8 /* PROPS */, _hoisted_8),
        _createElementVNode("input", {
          class: "nge-radio-vol",
          type: "range",
          min: "0",
          max: "1",
          step: "0.01",
          value: $setup.volume,
          tabindex: $setup.expanded ? 0 : -1,
          style: _normalizeStyle({ '--v': Math.round($setup.volume * 100) + '%' }),
          "aria-label": "Music volume",
          title: `Volume ${Math.round($setup.volume * 100)}%`,
          onInput: $setup.onVolume
        }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_11),
        _createElementVNode("span", _hoisted_12, _toDisplayString(Math.round($setup.volume * 100)), 1 /* TEXT */)
      ], 8 /* PROPS */, _hoisted_1),
      _createElementVNode("button", {
        class: "nge-radio-main",
        title: $setup.label,
        "aria-label": $setup.label,
        "aria-pressed": $setup.on,
        onClick: $setup.toggle
      }, [
        (_openBlock(), _createElementBlock("svg", _hoisted_14, [
          _hoisted_15,
          ($setup.level === 'off' || $setup.level === 'zero')
            ? (_openBlock(), _createElementBlock("path", _hoisted_16))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_17,
                ($setup.level === 'high')
                  ? (_openBlock(), _createElementBlock("path", _hoisted_18))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ])),
        _createElementVNode("span", _hoisted_19, [
          _createElementVNode("i", {
            style: _normalizeStyle({ transform: `scaleX(${$setup.progress})` })
          }, null, 4 /* STYLE */)
        ])
      ], 8 /* PROPS */, _hoisted_13)
    ], 38 /* CLASS, STYLE, HYDRATE_EVENTS */)
  ]))
}